<template>
    <component :is="resolvedBlock"
               v-if="block"
               :content="block.content"
               :alias="block.alias"
               v-bind="$attrs"/>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { HeadlessJsonContent } from '@/types/contentServerContract';
import { blockResolver, ClientComponentType } from '@/core/app/componentResolver.service';

defineOptions({ inheritAttrs: false });

const props = defineProps({
    block: { type: Object as PropType<HeadlessJsonContent>, required: true }
});

const resolvedBlock: ClientComponentType | null = computed(() => {
    return blockResolver.resolve(props.block.alias || '')?.component ?? null;
});

</script>
